import { api } from '@/api'
import BackLink from '@/components/BackLink'
import Container from '@/components/Container'
import WantToHoldChamp from '@/components/WantToHoldChamp'
import { usePage } from '@/hooks'
import { IChampionship } from '@/interfaces/Championship'
import React, { useEffect, useState } from 'react'
import TournamentInfo from './components/TournamentInfo'
import TournamentMembers from './components/TournamentMembers'

const TournamentsDetail = (): React.ReactElement => {
  const [championship, setChampionship] = useState<IChampionship>()
  const page = usePage()
  const { config } = page.init_state.global
  const { object } = page?.init_state

  const gameDetailUrl =
  championship?.game_id !== undefined
    ? `${config.detail_game}?element_id=${String(championship?.game_id)}`
    : undefined

  useEffect(() => {
    api
      .getChampionship({ id: object.id })
      .then((data) => {
        setChampionship(data)
      })
      .catch((error) => {
        console.log(error, 'error')
      })
  }, [])

  return (
    <>
      <Container>
        <BackLink href={config.tournaments} title='Все турниры' />
        <TournamentInfo
          id={object.id}
          currentUserRegistered={championship?.current_user_registered ?? true}
          gameId={championship?.game_id ?? ''}
          title={object.title}
          gameDetailUrl={gameDetailUrl}
          description={championship?.detail_text ?? ''}
          date={championship?.date_create ?? ''}
          isFinishedValue={championship?.property_is_finished_value ?? ''}
          registerClosedValue={championship?.property_tourney_register_closed_value ?? ''}
          stage={championship?.property_tournament_stage_value ?? '1'}
          image={championship?.detail_picture?.[0] ?? null}
        />

        <TournamentMembers
          tournament={championship}
        />
      </Container>

      <WantToHoldChamp
        title='Узнай больше о киберспортивном турнире по обучающей компьютерной игре «ЖЭКА»'
        blueButtonText='Положение о турнире'
      />
    </>
  )
}

export default TournamentsDetail
